import React, { useState, useEffect } from 'react';
import axios from 'axios';
import errorimage from '../../img/product/error.png'
import { Box, Typography, Dialog, DialogContent } from "@mui/material";
import ReportIcon from '@mui/icons-material/Report';

const EnAttente = ({ setActiveMenuItem, setIsLoading }) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [data, setData] = useState([])
    const [serverError, setServerError] = useState(false)
    const [popupOpen, setPopupOpen] = useState(false);
    const [rerender, setRerender] = useState(false)

    const handlePopupClose = () => {
        setPopupOpen(false);
    };

    const [orderId, setOrderId] = useState(null);
    const handleDeleteIconClick = (Id) => {
        setOrderId(Id);
        setPopupOpen(true);
    };

    useEffect(() => { setIsLoading(true); setActiveMenuItem('En attente'); axios.get(`${baseUrl}/orders`).then(({ data }) => { setData(data.reverse()); }).then(() => setIsLoading(false)).catch((err) => { console.log(err); setIsLoading(false); setServerError(true) }) }, [rerender]);
    //************************************* ERROR STYLING ************************************* */
    const containerStyle = {
        textAlign: 'center',
        marginTop: '50px',
    };

    const headingStyle = {
        fontSize: '2em',
        color: '#c0392b', // Red color
    };

    const messageStyle = {
        fontSize: '1.2em',
        marginBottom: '20px',
    };


    const detailsTextStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    };
    //****************************************** Error handling ********************************************************** */

    const [error, setError] = useState(null);
    const [showClass, setShowClass] = useState("");

    const handleError = (str) => {
        setError(str);
        setShowClass('show')
        setTimeout(() => {
            setError(null);
            setShowClass('')
        }, 5000);
    };
    //****************************************** Success handling ******************************************************* */
    const [success, setSuccess] = useState(null);
    const [successClass, setSuccessClass] = useState("");

    const handleSuccess = (str) => {
        setSuccess(str);
        setSuccessClass('showSuccess')
        setTimeout(() => {
            setSuccess(null);
            setSuccessClass('')
        }, 5000);
    };
    //******************************************** API REQUEST ************************************************************* */
    const hundleConfirm = (id) => {
        setIsLoading(true)
        axios.put(`${baseUrl}/orders/${id}`, { status: "confirmée" }).then(() => { handleSuccess("Commande confirmée !!"); setRerender(!rerender) }).catch((err) => { console.log(err); handleError('Problème de communication avec le serveur veuillez réessayer.') }).finally(() => { setIsLoading(false) });
    }

    const hundleDelete = () => {
        setIsLoading(true);
        setPopupOpen(false);
        axios.delete(`${baseUrl}/orders/${orderId}`).then(() => { handleSuccess("Commande supprimée !!"); setRerender(!rerender) }).catch((err) => { console.log(err); handleError('Problème de communication avec le serveur veuillez réessayer.') }).finally(() => { setIsLoading(false) });
    }



    return (
        <>
            {serverError && <section className="product-details spad">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="product__details__text" style={{ ...containerStyle, ...detailsTextStyle }}>
                                <img src={errorimage} alt="" style={{ width: '120px', height: '120px' }} />
                                <h3 style={headingStyle}>
                                    Error !!
                                </h3>
                                <p style={messageStyle}>Erreur de communication avec le serveur.</p>
                                <div className="product__details__button">
                                    <a className="cart-btn" onClick={() => { window.location.reload(); }} style={{ cursor: 'pointer' }}> Réessayer</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>}

            {!serverError && <section className="shop-cart spad">
                <div className="container">
                    <div className={`error-message ${showClass}`}>

                        <div className="close-button" onClick={() => { setError(null); setShowClass('') }}>
                            X
                        </div>
                        <div className="message-content">{error}</div>
                    </div>
                    <div className={`success-message ${successClass}`}>

                        <div className="close-buttonSuccess" onClick={() => { setSuccess(null); setSuccessClass('') }}>
                            X
                        </div>
                        <div className="message-contentSuccess">{success}</div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <h6 className="coupon__link">
                                <span className="icon_download"></span> Commandes en attente.
                            </h6>
                            <div className="shop__cart__table">
                                <table >
                                    <thead>
                                        <tr>
                                            <th>Produit</th>
                                            <th>Couleur</th>
                                            <th>Prix</th>
                                            <th>Quan</th>
                                            <th>Frais de livraison</th>
                                            <th>Total</th>
                                            <th>Client</th>
                                            <th>Téléph</th>
                                            <th>Adresse</th>
                                            <th>Note</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((row, index) => (
                                            row.status === "en attente" && <tr key={index}>
                                                <td className="cart__product__item">
                                                    <div className="cart__product__item__title">
                                                        <h6>{row.product_name} ({row.size})</h6>
                                                    </div>
                                                </td>
                                                <td style={{ textAlign: 'center' }} className="cart__price">
                                                    <span
                                                        style={{
                                                            display: 'inline-block',
                                                            width: '20px',
                                                            height: '20px',
                                                            borderRadius: '50%',
                                                            backgroundColor: row.color,
                                                            margin: 'auto',
                                                            marginTop: '10px',
                                                        }}
                                                    />
                                                </td>
                                                <td className="cart__price">{row.price} DT</td>
                                                <td className="cart__quantity">
                                                    <div className="pro-qty">
                                                        <input type="text" defaultValue={row.quantity} readOnly />
                                                    </div></td>
                                                <td className="cart__price">{row.shipping_fee} DT</td>
                                                <td className="cart__total">{row.shipping_fee + (row.price * row.quantity)} DT</td>
                                                <td>{row.client_name}</td>
                                                <td>{row.telephone}</td>
                                                <td>{row.address}</td>
                                                <td>{row.note}</td>
                                                <td className="cart__close">
                                                    <span className="icon_close" onClick={() => handleDeleteIconClick(row.id)}></span>
                                                    <span className="icon_check" style={{ marginTop: '10px' }} onClick={(e) => hundleConfirm(row.id)}></span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <Dialog open={popupOpen} onClose={handlePopupClose} >

                    <DialogContent sx={{ width: "310px", justifyContent: "center" }}>
                        <ReportIcon sx={{ ml: "115px", color: "#ff0000" }} />
                        <Typography variant="body1" color="#ff0000" sx={{ width: "250px", height: "45px", justifyContent: "center" }}>
                            <span style={{ marginLeft: "40px", fontWeight: 'bold' }}>Opération irréversible !</span>
                        </Typography>

                        <Box sx={{ display: "flex", justifyContent: "space-between", width: "250px", ml: "8px" }}>
                            <Box
                                m="0 auto"
                                mt="10px"
                                p="10px 20px"
                                display="flex"
                                justifyContent="center"
                                backgroundColor="#ff0000"
                                borderRadius="4px"
                                sx={{
                                    cursor: "pointer",
                                    width: "90px",
                                    height: "40px",
                                }}
                                onClick={hundleDelete}
                            >
                                <Typography color="#ffffff">
                                    Supprimer
                                </Typography>
                            </Box>

                            <Box
                                m="10px auto"
                                p="10px 20px"
                                display="flex"
                                justifyContent="center"
                                backgroundColor="#0b5707"
                                borderRadius="4px"
                                sx={{
                                    cursor: "pointer",
                                    width: "90px",
                                    height: "40px",
                                }}
                                onClick={handlePopupClose}
                            >
                                <Typography color="#ffffff">
                                    Annuler
                                </Typography>
                            </Box>
                        </Box>
                    </DialogContent>
                </Dialog>
            </section>}
        </>
    );
};

export default EnAttente;
